import AppContext from "../../Contexts/AppContext";

import MapComponent from "../../Map/MapComponent";
import React, { useState, useEffect, useRef, useContext } from "react";
import { FloatingWindow } from "../../modals/FloatingWindow/FloatingWindow";
import Header from "../../Interfaces/Header/Header";
import { AOIService } from "../../../services/MapCore/AOIService";
import Notiflix, { Loading } from "notiflix";
import { useSearchParams } from "react-router-dom";
import ProjectService from "../../../services/MapCore/ProjectService";
import { getLayerGroups } from "../../../api/ApiLayersGroup";
import { Slide, ToastContainer } from "react-toastify";

import authService from "../../../services/AuthService";
import "./Main.scss";
import BiodiversityLayerGroup from "../../../schemes/layer_groups/BiodiversityLayerGroup";

// import AOILayerGroup from "../../Map/Layers/LayerGroups/LayerAOI/AOILayerGroup";
import AOILayerGroup from "../../../schemes/layer_groups/AOILayerGroup";
// import DefaultLayerGroup from "../../Map/Layers/LayerGroups/DefaultLayerGroup/DefaultLayerGroup";
import DefaultLayerGroup from "../../../schemes/layer_groups/DefaultLayerGroup";
import BiodiversityDashboardLayerGroup from "../../../schemes/layer_groups/BiodiversityDashboard/BiodiversityDashboardLayerGroup";
import AsbestosLayerGroup from "../../../schemes/layer_groups/asbestos/AsbestosLayerGroup";
// import BiodiversityDashboardLayerGroup from "../../Map/Layers/LayerGroups/BiodiversityDashboard/BiodiversityDashboardLayerGroup";
// import AsbestosLayerGroup from "../../Map/Layers/LayerGroups/LayerAsbestos/AsbestosLayerGroup";

import { useTranslation } from "react-i18next";
import axios from "axios";
import { ControlPanel } from "../../Map/Controls/Controls";
import { Attributions } from "../../Map/Attributions/Attributions";
import AsbestosDashboardLayerGroup from "../../../schemes/layer_groups/asbestos/AsbestosDashboardLayerGroup";
import {
  createNewFeatureLayerToMap,
  createSinglePolygonEditMode,
} from "../../../services/MapCore/MapService";
import { Draw } from "ol/interaction";
import { defaults as defaultInteractions } from "ol/interaction";
import Joyride, { CallBackProps, STATUS, Step } from "react-joyride";
import LanguageSwitcher from "../../CustomComponents/LanguageSwitcher/LanguageSwitcher";
import { Box, Button, Modal } from "@mui/material";
// import GuidedPopover from "../../CustomComponents/Tutorial/GuidedPopover";
import Tutorial from "./Tutorial";
import CarbonSinkLayerGroup from "../../../schemes/layer_groups/carbon_sink/CarbonSinkLayerGroup";
import VegetationLayerGroup from "../../../schemes/layer_groups/vegetation/VegetationLayerGroup";
import ClimateLayerGroup from "../../../schemes/layer_groups/climate/ClimateLayerGroup";
import WaterSurfacesLayerGroup from "../../../schemes/layer_groups/water_surfaces/WaterSurfacesLayerGroup";
import PollutionLayerGroup from "../../../schemes/layer_groups/pollution/PollutionLayerGroup";
import CarbonSinkSpLayerGroup from "../../../schemes/layer_groups/carbon_sink_sp/CarbonSinkSpLayerGroup";
import CarbonSinkPtLayerGroup from "../../../schemes/layer_groups/carbon_sink_pt/CarbonSinkPtLayerGroup";
// import GuidedOverlay from "../../CustomComponents/Tutorial/GuidedOverlay";

const Main = () => {
  const { t, i18n } = useTranslation("main");
  const [searchParams, setSearchParams] = useSearchParams();

  const projectUuid = searchParams.get("project_uuid");

  const {
    layersGroups,
    setLayersGroups,
    selectedFeatures,
    setSelectedFeatures,
    mapInstanceRef,
    aoiUuid,
    setAoiUuid,
    layersGroupsRef,
    setAoiExtent,
    isWindowFeatureDetailsOpen,
    setIsWindowFeatureDetailsOpen,
    setIsWindowLayerDashboardOpen,
    setDashboardsToShow,
    project,
    setProject,
    loadingClick,
    setUserProjects,
    editedGeometry,
    setEditedGeometry,
    modeOptions,
    setModeOptions,
    menuRef,
    // sidebarRef,
    mapControlsRef,
    showTutorialCarbonWindow,
  } = useContext(AppContext);

  const [selectedFeaturesAttempt, setSelectedFeaturesAttempt] = useState(0);

  useEffect(() => {
    setSelectedFeaturesAttempt((curr) => curr + 1);
  }, [selectedFeatures]);

  useEffect(() => {
    const getProjects = async () => {
      try {
        const userProjects = await ProjectService.get_projects();

        setUserProjects(userProjects);

        if (!projectUuid) {
          searchParams.set("project_uuid", userProjects[0]?.uuid);
          setSearchParams(searchParams);
          console.error("project_uuid no encontrado!");
        }

        return userProjects;
      } catch (error) {
        console.error("Error al obtener los proyectos:", error);
      }
    };

    const updateAoiUUID = async (project_uuid, userProjects) => {
      try {
        const current_project =
          await ProjectService.get_project_by_uuid(project_uuid);
        const current_aoi_uuid = current_project?.aoi?.uuid;
        setProject(current_project);

        if (aoiUuid != current_aoi_uuid) {
          setAoiUuid(current_aoi_uuid);
          const aoi_extent = await AOIService.get_aoi_extent(
            encodeURI(`uuid='${current_aoi_uuid}'`)
          );
          if (aoi_extent) {
            setAoiExtent(aoi_extent);
            AOIService.center_map_from_extent(
              mapInstanceRef.current,
              aoi_extent
            );
          }
        }
      } catch (error) {
        if (axios.isAxiosError(error) && error.response?.status === 404) {
          console.warn(`Proyecto no encontrado: ${project_uuid}`, userProjects);
          searchParams.set("project_uuid", userProjects[0]?.uuid);
          setSearchParams(searchParams);
          console.error("project_uuid no encontrado!");
        }
      }
    };

    const fetchData = async () => {
      Loading.circle();
      const userProjects = await getProjects(); // Asegurarse de que es un array
      if (mapInstanceRef.current && projectUuid) {
        await updateAoiUUID(projectUuid, userProjects);
      }
      Loading.remove();
    };

    fetchData(); // Llamar a la función asincrónica correctamente
  }, [searchParams]);

  useEffect(() => {
    if (project?.title?.[i18n.language]) {
      document.title =
        project?.title?.[i18n.language] + " - " + project?.category;
    } else {
      document.title = "Agforest Visor";
    }
  }, [project, i18n.language]);

  useEffect(() => {
    const process_layer_groups = async () => {
      const layer_groups_data = await getLayerGroups(project?.uuid);

      const TYPE_MAP = {
        ASBESTOS: AsbestosDashboardLayerGroup, //AsbestosLayerGroup, // AsbestosDashboardLayerGroup
        DEFAULT: DefaultLayerGroup,
        BIODIVERSITY: BiodiversityLayerGroup,
        BIODIVERSITY_DASHBOARD: BiodiversityDashboardLayerGroup,
        CARBON_SINK_GROUND_USE: CarbonSinkLayerGroup,
        CARBON_SINK_GROUND_USE_SP: CarbonSinkSpLayerGroup,
        CARBON_SINK_GROUND_USE_PT: CarbonSinkPtLayerGroup,
        VEGETATION_NDVI_SAVI: VegetationLayerGroup,
        CLIMATE: ClimateLayerGroup,
        WATER_SURFACES: WaterSurfacesLayerGroup,
        POLLUTION: PollutionLayerGroup,
      };

      const layer_groups_to_add = [
        new AOILayerGroup(
          mapInstanceRef.current,
          project?.aoi.name,
          aoiUuid,
          project?.aoi?.aoi_type
        ),
      ];

      // Limpia las interacciones anteriores antes de crear los nuevos
      mapInstanceRef.current.getInteractions().clear();
      defaultInteractions().forEach((interaction) => {
        mapInstanceRef.current.addInteraction(interaction);
      });

      // const interactionsToRemove = mapInstanceRef.current
      //   .getInteractions()
      //   .getArray()
      //   .filter((interaction) =>
      //     interactionTypesToRemove.some((type) => interaction instanceof type)
      //   );

      // interactionsToRemove.forEach((interaction) =>
      //   mapInstanceRef.current.removeInteraction(interaction)
      // );

      if (layer_groups_data && layer_groups_data.length > 0) {
        for (const layer_group_data of layer_groups_data.sort(
          (a, b) => Number(a.order) - Number(b.order)
        )) {
          if (
            "layer_group_type" in layer_group_data &&
            layer_group_data["layer_group_type"] in TYPE_MAP
          ) {
            const layer_group_type = layer_group_data["layer_group_type"];

            layer_groups_to_add.push(
              new TYPE_MAP[layer_group_type](
                mapInstanceRef.current,
                layer_group_data
              )
            );
          } else {
            layer_groups_to_add.push(
              new TYPE_MAP["DEFAULT"](mapInstanceRef.current, layer_group_data)
            );
          }
        }
      }

      layersGroupsRef.current = layer_groups_to_add;
      setLayersGroups(layer_groups_to_add);
    };

    const update_aoi = async () => {
      await process_layer_groups();
      setIsWindowFeatureDetailsOpen(false);
      setIsWindowLayerDashboardOpen(false);
      setDashboardsToShow([]);

      setTimeout(() => {
        document.removeEventListener(
          "dashboard-open-request",
          handleDashboardEvent
        );
        document.addEventListener(
          "dashboard-open-request",
          handleDashboardEvent
        );
      }, 1000);
    };

    if (mapInstanceRef.current && aoiUuid) {
      update_aoi();
    } else {
    }
    return () => {
      document.removeEventListener(
        "dashboard-open-request",
        handleDashboardEvent
      );
    };
  }, [project, mapInstanceRef]);

  useEffect(() => {
    console.log(
      "project?.category.includes(CARBON_SINK)",
      project?.category.includes("CARBON_SINK")
    );
    if (project?.category.includes("CARBON_SINK")) {
      const layer = layersGroupsRef.current
        .find((layer_group) =>
          layer_group?.layer_group_data?.layer_group_type.includes(
            "CARBON_SINK_GROUND_USE"
          )
        )
        ?.layer_list_data.find((layer) =>
          layer.layer_type.includes("CARBON_SINK_GROUND_USES")
        );
      console.log("layer", layer, layersGroupsRef.current);

      setModeOptions((prev) => ({
        ...prev,
        CARBON_SINK: [layer?.uuid],
      }));

      createSinglePolygonEditMode({
        map: mapInstanceRef.current,
        layer: layer,
        setEditedGeometry,
      });
    }
  }, [layersGroups]);

  const handleCloseWindowFeatureDetails = () => {
    setSelectedFeatures([]);
    setIsWindowFeatureDetailsOpen(false);
    if (mapInstanceRef.current) {
      let markerLayer = mapInstanceRef.current
        .getLayers()
        .getArray()
        .find((layer) => layer.get("name") === "markerLayer");
      if (markerLayer) {
        markerLayer.getSource().clear();
      }
    }
  };

  const handleDashboardEvent = () => {
    if (!layersGroupsRef) return;
    let dashboards = layersGroupsRef.current
      .filter((lg) => lg.has_dashboard)
      .map((selectedLayer) => {
        return {
          id: selectedLayer.id,
          dashboard: selectedLayer.dashboard,
          layerGroup: selectedLayer,
        };
      });

    if (dashboards.length > 0) {
      setDashboardsToShow(dashboards);
      setIsWindowLayerDashboardOpen(true);
    }
  };
  return (
    <>
      <div
        style={{
          height: "100vh",
          height: "100dvh",
          boxSizing: "border-box",
          position: "relative",
          overflow: "hidden",
        }}
      >
        <Header
          showHelpButton={false}
          enableToolbar={true}
          enableSearchBar={true}
        />
        <ToastContainer
          stacked
          position="top-right"
          style={{ top: "90px" }}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick={false}
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
          theme="light"
          transition={Slide}
        />
        <div
          style={{
            width: "100%",
            height: "100%",
            ...(modeOptions?.ASBESTOS_CLICK?.length > 0 && {
              boxShadow: "inset 0px 0px 20px 10px rgba(255,0,0,1)",
            }),
          }}
        >
          <MapComponent />
          <ControlPanel map={mapInstanceRef.current} />
          <Attributions />
          <FloatingWindow
            content={selectedFeatures}
            onClose={handleCloseWindowFeatureDetails}
            open={
              ((modeOptions.ADD_POLYGON.length > 0 ||
                modeOptions.CARBON_SINK.length > 0) &&
                editedGeometry) ||
              (selectedFeatures.length > 0 &&
                (isWindowFeatureDetailsOpen || loadingClick)) ||
              showTutorialCarbonWindow
            }
          />
          <Tutorial />
        </div>
      </div>
    </>
  );
};
export default Main;
